import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e31acfa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Back to Units")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Unit", -1))
const _hoisted_4 = { key: 2 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Size", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Plans", -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Override Price Plan")
], -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("months")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" month")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Gate Key", -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Deposit", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Setup Fee", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Reservation Price", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Customer Access", -1))
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rented to", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Billing Cycle", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Next Bill", -1))
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Reserved to", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Status", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Notes", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Created", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Updated", -1))
const _hoisted_29 = {
  key: 1,
  class: "customer-select"
}
const _hoisted_30 = ["value"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" Rent to Customer ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Reserve for Customer")
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Rent to Customer", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Reserve for Customer", -1))
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Rent to New Customer ")
const _hoisted_39 = { key: 3 }

import { ref } from "vue";

import api from "@virgodev/bazaar/functions/api";
import { CustomerDataInterface, ReservationInterface } from "@/types/customers";
import UnitStatusModal from "../../components/UnitStatusModal.vue";
// const router = useRouter();
import BaseSpinner from "../../components/BaseSpinner.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const unitStatusChange = ref(false);
const unit = ref();
const errors = ref("");
const customer = ref();
const status = ref("loading");
const customers = ref(Array<CustomerDataInterface>());
const chosenCustomer = ref(null);
const editKey = ref(false);
const submittingKey = ref(false);
const newGateKey = ref();
const reservedTo = ref({
  unit_id: "",
  customer_id: "",
  move_in_on: "",
});


async function updateKey() {
  errors.value = "";
  submittingKey.value = true;
  const response = await api({
    url: `units/?id=${props.id}&facilityId=${props.facilityId}`,
    method: "PUT",
    json: JSON.parse(
      JSON.stringify({
        name: unit.value.name,
        unit_type_id: unit.value.unit_type_id,
        gate_key: newGateKey.value,
      })
    ),
  });
  if (response.status == 200) {
    editKey.value = false;
    unit.value.gate_key = newGateKey.value;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  submittingKey.value = false;
}
async function getUnit() {
  errors.value = "";
  const response = await api({
    url: `units/?id=${props.id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unit.value = response.body;
    newGateKey.value = response.body.gate_key;

    if (response.body.unit) {
      unit.value = response.body.unit;
    }
    if (["pending", "reserved"].includes(response.body.status)) {
      await getReservations();
    }
    if (
      (unit.value.customer_id || unit.value.current_tenant_id) &&
      unit.value.status != "available"
    ) {
      let customer = unit.value.customer_id;
      if (!customer) {
        customer = unit.value.current_tenant_id;
      }
      await getCustomer(customer);
    } else {
      await getCustomers();
    }

    if (unit.value.unit_group_id) {
      await getUnitTypes(unit.value.unit_group_id);
    } else {
      await getUnitTypes(unit.value.unit_type_id);
    }
    status.value = "loaded";
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function modalClosed() {
  unitStatusChange.value = false;
  await getUnit();
}
async function getReservations() {
  errors.value = "";
  const response = await api({
    url: `reservations/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let reservations = response.body;
    if (reservations) {
      reservedTo.value = reservations.filter(
        (item: ReservationInterface) => item.unit_id == unit.value.id
      )[0];
      if (reservedTo.value && reservedTo.value.customer_id) {
        await getCustomer(reservedTo.value.customer_id);
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomers() {
  errors.value = "";
  const response = await api({
    url: `customers/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customers.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomer(id: string) {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
    await getRental();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getRental() {
  errors.value = "";
  const response = await api({
    url: `rentals/?id=${unit.value.customer_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let rentals = response.body;
    for (let rental of rentals) {
      if (rental.unit_id == unit.value.id) {
        customer.value.rental = rental;
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getUnitTypes(id: string) {
  errors.value = "";
  const response = await api({
    url: `unit_types/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unit.value.unit_type = response.body;
    let plans = await getPlans(Number(id));
    unit.value.unit_type.plans = plans.filter(
      (item: { amount: number }) => item.amount && item.amount > 0
    );
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPlans(unit_type_id: number) {
  errors.value = "";
  let url = `plans/?facilityId=${props.facilityId}&unit_type_id=${unit_type_id}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    return null;
  }
}
getUnit();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createBlock(_component_RouterLink, {
          key: 1,
          to: {
        name: 'units',
        params: { facilityId: __props.facilityId, facilityName: 'ESS' },
      }
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["to"])),
    _hoisted_3,
    (unit.value && unit.value.unit_type)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h3", null, "Name / Number: " + _toDisplayString(unit.value.name), 1),
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _hoisted_5,
              _createElementVNode("td", null, [
                (unit.value.unit_type.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(unit.value.unit_type.length), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (unit.value.unit_type.width)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" x " + _toDisplayString(unit.value.unit_type.width), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (unit.value.unit_type.height)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" x " + _toDisplayString(unit.value.unit_type.height), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                (
                unit.value.unit_type.length == 0 &&
                unit.value.unit_type.width == 0 &&
                unit.value.unit_type.height == 0
              )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _createTextVNode(_toDisplayString(unit.value.unit_type.name), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_6,
              _createElementVNode("td", null, "$" + _toDisplayString(unit.value.unit_type.price) + " per month", 1)
            ]),
            (unit.value.unit_type.plans && unit.value.unit_type.plans.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("td", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unit.value.unit_type.plans, (plan) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: plan.id + 'plan'
                      }, [
                        (plan.amount)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" $ " + _toDisplayString(plan.amount) + " per " + _toDisplayString(plan.months) + " ", 1),
                              (plan.months > 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_9
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_10
                                  ], 64))
                            ], 64))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _hoisted_11,
              (!editKey.value)
                ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                    _createTextVNode(_toDisplayString(unit.value.gate_key) + " ", 1),
                    (unit.value.gate_key && unit.value.gate_key.length)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-blue",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (editKey.value = true))
                        }, " Edit "))
                      : (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "btn btn-blue",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (editKey.value = true))
                        }, " Add "))
                  ]))
                : (_openBlock(), _createElementBlock("td", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newGateKey).value = $event)),
                      type: "text"
                    }, null, 512), [
                      [_vModelText, newGateKey.value]
                    ]),
                    _createElementVNode("button", {
                      class: "btn btn-blue",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (updateKey()))
                    }, "Update"),
                    _createElementVNode("button", {
                      class: "btn btn-blue",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (editKey.value = false))
                    }, " Cancel ")
                  ]))
            ]),
            _createElementVNode("tr", null, [
              _hoisted_14,
              _createElementVNode("td", null, _toDisplayString(unit.value.unit_type.deposit), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_15,
              _createElementVNode("td", null, _toDisplayString(unit.value.unit_type.setup_fee), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_16,
              _createElementVNode("td", null, _toDisplayString(unit.value.unit_type.reservation_price), 1)
            ]),
            (
            !['available', 'pending', 'reserved'].includes(unit.value.status) &&
            customer.value
          )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("tr", null, [
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      (customer.value.locked_out_at)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(customer.value.locked_out_at), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, "Not locked out"))
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_20,
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: {
                  name: 'customer_detail_ess',
                  params: { id: customer.value.id, facilityId: __props.facilityId },
                }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(customer.value.name), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createTextVNode(" on " + _toDisplayString(customer.value.rental.rented_on), 1)
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_21,
                    _createElementVNode("td", null, " $" + _toDisplayString(customer.value.rental.price) + " / " + _toDisplayString(customer.value.rental.billing_cycle) + " month ", 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _hoisted_22,
                    _createElementVNode("td", null, _toDisplayString(customer.value.rental.next_due_on), 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (reservedTo.value && customer.value)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("td", null, [
                    _createVNode(_component_RouterLink, {
                      to: {
                name: 'customer_detail_ess',
                params: { id: customer.value.id, facilityId: __props.facilityId },
              }
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(customer.value.name), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createTextVNode(" on " + _toDisplayString(reservedTo.value.move_in_on), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("tr", null, [
              _hoisted_25,
              _createElementVNode("td", null, [
                _createTextVNode(_toDisplayString(unit.value.status) + " ", 1),
                (
                !['reserved', 'pending', 'moving_out'].includes(unit.value.status)
              )
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (unitStatusChange.value = true))
                    }, "-change status"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_26,
              _createElementVNode("td", null, _toDisplayString(unit.value.notes), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_27,
              _createElementVNode("td", null, _toDisplayString(unit.value.created_at), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_28,
              _createElementVNode("td", null, _toDisplayString(unit.value.updated_at), 1)
            ])
          ]),
          (unitStatusChange.value)
            ? (_openBlock(), _createBlock(UnitStatusModal, {
                key: 0,
                "unit-name": unit.value.name,
                "unit-status": unit.value.status,
                "unit-id": unit.value.id,
                "unit-type-id": unit.value.unit_type_id,
                "facility-id": __props.facilityId,
                onModalClosed: modalClosed
              }, null, 8, ["unit-name", "unit-status", "unit-id", "unit-type-id", "facility-id"]))
            : _createCommentVNode("", true),
          (customers.value && unit.value.status == 'available')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((chosenCustomer).value = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customers.value, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id + 'customer',
                      value: c.id
                    }, _toDisplayString(c.name), 9, _hoisted_30))
                  }), 128))
                ], 512), [
                  [_vModelSelect, chosenCustomer.value]
                ]),
                (chosenCustomer.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createVNode(_component_RouterLink, {
                        to: {
              name: 'rental',
              params: {
                facilityId: __props.facilityId,
                customerId: chosenCustomer.value,
                unitType: 'null',
                unitId: unit.value.id,
                unitStatus: 'available',
              },
            },
                        class: "btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_32
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_RouterLink, {
                        to: {
              name: 'reserve_unit',
              params: {
                customerId: chosenCustomer.value,
                unitId: unit.value.id,
                facilityId: __props.facilityId,
              },
            },
                        class: "btn"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_37)),
                _createVNode(_component_RouterLink, {
                  to: {
            name: 'customer',
            params: {
              unitId: unit.value.id,
              facilityId: __props.facilityId,
              rental: 'false',
              customerId: null,
            },
          },
                  class: "btn"
                }, {
                  default: _withCtx(() => [
                    _hoisted_38
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (errors.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(errors.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})